import { readStorage, removeStorage, writeStorage } from './storageKeys.js';

const suffix = (userId, projectId) => `draft.${userId}.${projectId}`;
export function readDraft(userId, projectId) {
  try {
    const value = JSON.parse(readStorage(suffix(userId, projectId)));
    return value?.doc && ['walls', 'areas', 'cams', 'models'].every(k => Array.isArray(value.doc[k])) ? value : null;
  } catch { return null; }
}
export function writeDraft(userId, projectId, doc, baseRev) {
  writeStorage(suffix(userId, projectId), JSON.stringify({ doc, baseRev, savedAt: new Date().toISOString() }));
}
export function clearDraft(userId, projectId) {
  try { removeStorage(suffix(userId, projectId)); } catch { /* storage may be unavailable */ }
}
